// extracted by mini-css-extract-plugin
export var fullWidthButton = "_dw-0";